const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

function registerValidServiceWorker(serviceWorkerUrl) {
  navigator.serviceWorker
    .register(serviceWorkerUrl, { updateViaCache: "none" })
    .then((registration) => {
      registration.update().catch(() => {
        // A temporary offline state must not break application startup.
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;

        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (
            installingWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            console.info("نسخه جدید sfarm دریافت شد و با بارگذاری بعدی فعال می‌شود.");
          }
        };
      };
    })
    .catch((error) => {
      console.error("ثبت Service Worker ناموفق بود:", error);
    });
}

function checkValidServiceWorker(serviceWorkerUrl) {
  fetch(serviceWorkerUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");

      if (
        response.status === 404 ||
        (contentType && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
        return;
      }

      registerValidServiceWorker(serviceWorkerUrl);
    })
    .catch(() => {
      console.info("sfarm در حال حاضر بدون اتصال شبکه اجرا شده است.");
    });
}

export function register() {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener("load", () => {
    const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(serviceWorkerUrl);
    } else {
      registerValidServiceWorker(serviceWorkerUrl);
    }
  });
}
